import { httpsCallable, HttpsCallableResult } from 'firebase/functions';
import { functions } from '@/config/firebase';

/**
 * Generic type-safe callable function wrapper
 */
export const callFunction = async <TRequest, TResponse>(
  functionName: string,
  data: TRequest
): Promise<TResponse> => {
  const callable = httpsCallable<TRequest, TResponse>(functions, functionName);
  const result: HttpsCallableResult<TResponse> = await callable(data);
  return result.data;
};

/**
 * Firebase Functions service wrapper
 * Provides typed callable functions for admin operations
 */
export const functionsService = {
  /**
   * Call a Firebase callable function with type safety
   */
  call: callFunction,

  /**
   * Get a callable function reference
   */
  getCallable: <TRequest, TResponse>(functionName: string) => {
    return httpsCallable<TRequest, TResponse>(functions, functionName);
  },
};

export default functionsService;
